import api from "@/api";
import DataResponse from "@/types/DataResponse";

async function getThreedsToken(): Promise<DataResponse<{ session: string; expires_at: number }>> {
  const response = await api.get<DataResponse<{ session: string; expires_at: number }>>("/api/checkout/threeds");
  return response.data;
}

export default getThreedsToken;
